import PropTypes from 'prop-types';
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Container, Toolbar } from '@mui/material';

import { styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';
import Header from './Header';
const FooterBlock = lazy(() => import('./FooterBlock'));

const LoaderWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2001,
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2)
  }
}));

const Loader = () => (
  <LoaderWrapper>
    <LinearProgress color="primary" />
  </LoaderWrapper>
);

const CommonLayout = (layout = 'blank') => {
    console.log(layout.layout)
    return(
        <>
            <Suspense fallback={<Loader />}>
              <Header layout={layout.layout} />
              <Outlet />
              <FooterBlock isFull={true} />
            </Suspense>
        </>
    )
};
CommonLayout.propTypes = {
  layout: PropTypes.string
};


export default CommonLayout;